import Api from './Api';

export default {
    CreateRole(payload) {
        return Api().post(`/role_features`, payload)
    },
    UpdateRole(payload) {
        return Api().put(`/role_features`, payload)
    },
    ReadRoleById(payload) {
        return Api().get(`/role_features/${payload}`)
    },
    UpdateRoleById(payload) {
        return Api().put(`/role_features/${payload.role_featuresId}`, payload)
    },
    ReadAllRoles() {
        return Api().get(`/role_features`)
    },
    getFeatures(payload) {
        return Api().get(`/get_features/module_id-${payload}`)
    },
}



// WEBPACK FOOTER //
// ./src/services/UserPermission.js